import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-inbox-management }}\n<WelcomeHelpdesk />",{ moduleName: "embercom/templates/apps/app/welcome-helpdesk.hbs" })